import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const defaultLocale = 'en';

type SettingsStore = {
  locale: 'en' | 'de' | 'pt' | 'nl';
  showSettingsState: boolean;
  globalHeight: number;
  setShowSettingsState: (value: boolean) => void;
  setGlobalHeight: (value: number) => void;
  setLocale: (locale: 'en' | 'de' | 'pt' | 'nl') => void;
};

export const useSettingsStore = create<SettingsStore>()(
  persist(
    (set) => ({
      locale: defaultLocale,
      showSettingsState: false,
      globalHeight: window.innerHeight,
      setGlobalHeight: (value) => set({ globalHeight: value }),
      setLocale: (value) => set({ locale: value }),
      setShowSettingsState: (value) => set({ showSettingsState: value }),
    }),
    {
      name: 'settings-storage',
    },
  ),
);
